<template>
  <div class="Reason">
    <Row>
      <Column class="icon-col" :sm="4" :xs="12">
        <Icon :name="reason.icon" />
      </Column>
      <Column class="text-col" :sm="8" :xs="12">
        <span class="label">{{ reason.label }}</span>
        <p class="description">
          {{ reason.description }}
        </p>
      </Column>
    </Row>
  </div>
</template>

<script>
export default {
  props: {
    reason: Object,
  },
}
</script>

<style lang="scss">
.Reason {
  padding: 1rem;
  @include md {
    padding: 3rem;
  }

  .icon-col {
    color: $grey;
    font-size: 7rem;
    min-width: 100px;
    text-align: center;
  }

  .text-col {
    span {
      display: block;
    }

    .label {
      color: $main;
      font-weight: $bold;
      padding-bottom: 1rem;
      text-transform: uppercase;
    }

    .description {
      color: $grey;
    }
  }
}
</style>
